import { Collapsible, styled, EditIcon } from '@showroomjs/ui';
import * as React from 'react';
import { Div, A as Link, Span } from './base';
export const TableOfContent = ({ headings, editUrl, }) => {
    const [submenuIsOpen, setSubmenuIsOpen] = React.useState(false);
    const hasHeadings = headings && headings.length > 0;
    return (React.createElement(Div, { css: {
            '@xl': {
                paddingLeft: '$6',
                width: '25%',
                position: 'sticky',
                top: 64,
                bottom: 0,
                maxHeight: 'calc(100vh - 58px - 2rem)',
            },
        } },
        hasHeadings && (React.createElement(Collapsible.Root, { open: submenuIsOpen, onOpenChange: setSubmenuIsOpen, css: {
                py: '$3',
                borderRadius: '$md',
                overflow: 'hidden',
                marginX: '-8px',
                '@sm': {
                    marginX: 0,
                },
                '@xl': {
                    display: 'none',
                },
            } },
            React.createElement(Collapsible.Button, { css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    py: '$2',
                    px: '$4',
                    backgroundColor: '$gray-100',
                } },
                "In this page",
                React.createElement(Collapsible.ToggleIcon, { hide: submenuIsOpen, "aria-label": submenuIsOpen ? 'Hide' : 'View', width: "16", height: "16" })),
            React.createElement(Collapsible.Content, { css: {
                    backgroundColor: '$gray-50',
                    paddingBottom: '$1',
                } },
                React.createElement(List, { css: {
                        maxHeight: 300,
                        '@md': {
                            maxHeight: 500,
                        },
                        px: '$2',
                        overflowY: 'auto',
                    } }, headings.map((heading, index) => (React.createElement(Item, { css: {
                        paddingLeft: (heading.rank - 2) * 24,
                    }, key: index }, heading.id ? (React.createElement(A, { href: `#${heading.id}`, dangerouslySetInnerHTML: { __html: heading.text } })) : (React.createElement("div", { dangerouslySetInnerHTML: { __html: heading.text } }))))))))),
        editUrl ? (React.createElement(Div, { css: {
                '@xl': {
                    display: 'none',
                },
            } },
            React.createElement(EditLink, { floatRight: true, url: editUrl }))) : null,
        React.createElement(Div, { css: {
                display: 'none',
                '@xl': {
                    display: 'block',
                },
                position: 'sticky',
                top: 0,
                py: '$4',
            } },
            React.createElement(Div, { css: { position: 'relative' } },
                React.createElement(Div, { css: {
                        pointerEvents: 'none',
                        height: '3rem',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 10,
                        backgroundImage: 'linear-gradient(to bottom, rgba(249,250,251,1) 0%, rgba(249,250,251,0) 100%)',
                    } }),
                React.createElement(Div, { css: {
                        maxHeight: '80vh',
                        overflow: 'auto',
                        py: '$6',
                        borderLeft: '1px solid $gray-300',
                        overscrollBehavior: 'contain',
                    } }, hasHeadings && (React.createElement(React.Fragment, null,
                    React.createElement(Div, { css: {
                            color: '$gray-400',
                            paddingLeft: 24,
                            marginBottom: '$2',
                            textTransform: 'uppercase',
                            fontSize: '$sm',
                            fontWeight: 'bold',
                            letterSpacing: '0.05em',
                        } }, "In this page"),
                    React.createElement(List, null, headings.map((heading, index) => (React.createElement(Item, { css: {
                            paddingLeft: 16 + (heading.rank - 2) * 24,
                        }, key: index }, heading.id ? (React.createElement(A, { href: `#${heading.id}`, dangerouslySetInnerHTML: { __html: heading.text } })) : (React.createElement("div", { dangerouslySetInnerHTML: { __html: heading.text } }))))))))),
                React.createElement(Div, { css: {
                        pointerEvents: 'none',
                        height: '3rem',
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 10,
                        backgroundImage: 'linear-gradient(to top, rgba(249,250,251,1) 0%, rgba(249,250,251,0) 100%)',
                    } })),
            editUrl ? (React.createElement(Div, { css: {
                    position: 'fixed',
                    bottom: '$6',
                    paddingLeft: '$3',
                } },
                React.createElement(EditLink, { url: editUrl }))) : null)));
};
const List = styled('ul', {
    listStyle: 'none',
    margin: 0,
    padding: 0,
});
const Item = styled('li');
const A = styled('a', {
    display: 'inline-block',
    px: '$2',
    py: '$2',
    fontSize: '$sm',
    textDecoration: 'none',
    color: 'inherit',
});
const EditLink = (props) => (React.createElement(Link, { css: {
        float: props.floatRight ? 'right' : undefined,
        display: props.fullWidth ? 'flex' : 'inline-flex',
        alignItems: 'center',
        gap: '$2',
        fontSize: '$xs',
        paddingInline: '$3',
        paddingBlock: '$1',
        color: '$gray-400',
        '&:hover': {
            backgroundColor: '$gray-100',
        },
    }, href: props.url, target: "_blank", rel: "noopener noreferrer" },
    React.createElement(Span, { css: {
            color: '$gray-500',
            fontWeight: 500,
            letterSpacing: '0.05em',
        } }, "EDIT THIS PAGE"),
    React.createElement(EditIcon, { width: 16, height: 16 })));
//# sourceMappingURL=table-of-content.js.map